import { useTranslation } from "react-i18next";

const useCommon = () => {
  const { t } = useTranslation();
  return t;
};

export default useCommon;
